
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { DepartmentItemProps } from ".";
import { loading, endLoading } from "store/department";

interface ApiDepartmentRemoveInputProps {
    ids: number[]
}

type ApiDepartmentRemoveOutputProps = OutputBaseProps<{ item: DepartmentItemProps; }, []>;

export const apiDepartmentRemove = async (data: ApiDepartmentRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiDepartmentRemoveOutputProps>("/api/department/remove", { data }))
        .data;
    store.dispatch(endLoading());
    return res;
};